(() => {
  const slugify = (text) =>
    text
      .toLowerCase()
      .trim()
      .replace(/[^\p{L}\p{N}\s-]/gu, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');


  const buildToc = (root) => {
    const content =
      root.querySelector('[data-kf-article-content]');

    const toc =
      root.querySelector('[data-kf-toc]');

    const tocList =
      root.querySelector('[data-kf-toc-list]');

    const mobileToc =
      root.querySelector('[data-kf-mobile-toc]');

    const mobileTocList =
      root.querySelector('[data-kf-mobile-toc-list]');


    if (!content) return;


    if (tocList) {
      tocList.innerHTML = '';
    }

    if (mobileTocList) {
      mobileTocList.innerHTML = '';
    }


    const headings =
      Array.from(
        content.querySelectorAll('h2')
      ).filter(
        (heading) =>
          heading.textContent.trim().length > 0
      );


    if (headings.length < 3) {

      root.classList.add(
        'kf-article--no-toc'
      );

      if (toc) {
        toc.hidden = true;
      }

      if (mobileToc) {
        mobileToc.hidden = true;
      }

      return;
    }


    root.classList.remove(
      'kf-article--no-toc'
    );


    const usedIds = new Set();


    headings.forEach(
      (heading, index) => {

        let baseId =
          heading.id ||
          slugify(heading.textContent) ||
          `section-${index + 1}`;

        let uniqueId = baseId;
        let suffix = 2;


        while (
          usedIds.has(uniqueId) ||
          (
            document.getElementById(uniqueId) &&
            document.getElementById(uniqueId) !== heading
          )
        ) {

          uniqueId =
            `${baseId}-${suffix}`;

          suffix += 1;
        }


        heading.id = uniqueId;
        usedIds.add(uniqueId);


        const makeItem = () => {

          const li =
            document.createElement('li');

          const link =
            document.createElement('a');

          link.href =
            `#${uniqueId}`;

          link.textContent =
            heading.textContent.trim();

          li.appendChild(link);

          return li;
        };


        if (tocList) {
          tocList.appendChild(
            makeItem()
          );
        }

        if (mobileTocList) {
          mobileTocList.appendChild(
            makeItem()
          );
        }

      }
    );


    if (toc) {
      toc.hidden = false;
    }

    if (mobileToc) {
      mobileToc.hidden = false;

      mobileToc
        .querySelectorAll('a')
        .forEach(
          (link) => {

            link.addEventListener(
              'click',
              () => {
                mobileToc.open = false;
              }
            );

          }
        );
    }
  };


  const getViewportHeight = (root) => {
    const scroller =
      root.closest('.page-wrapper');

    return (
      scroller?.clientHeight ||
      window.innerHeight
    );
  };


  const clearStickyState = (element) => {
    if (!element) return;

    element.classList.remove(
      'is-sticky-side'
    );

    element.style.removeProperty(
      '--kf-side-sticky-top'
    );
  };


  const applyStickyState = (
    element,
    elementHeight,
    viewportHeight
  ) => {
    const topGap = 110;
    const bottomGap = 24;

    let stickyTop = topGap;


    /*
      If the shorter side itself is taller than the viewport,
      allow it to scroll normally first.

      Once its bottom reaches the lower viewport edge,
      the negative top value makes it hold there while the
      taller side continues.
    */

    if (
      elementHeight >
      viewportHeight - topGap - bottomGap
    ) {

      stickyTop =
        viewportHeight -
        elementHeight -
        bottomGap;
    }


    element.style.setProperty(
      '--kf-side-sticky-top',
      `${stickyTop}px`
    );

    element.classList.add(
      'is-sticky-side'
    );
  };


  const updateBalancedSticky = (root) => {
    const centre =
      root.querySelector(
        '[data-kf-article-centre]'
      );

    const media =
      root.querySelector(
        '[data-kf-media-rail]'
      );


    clearStickyState(
      centre
    );

    clearStickyState(
      media
    );


    if (
      !centre ||
      !media ||
      window.matchMedia(
        '(max-width: 989px)'
      ).matches
    ) {
      return;
    }


    const centreHeight =
      centre.getBoundingClientRect().height;

    const mediaHeight =
      media.getBoundingClientRect().height;

    const difference =
      Math.abs(
        centreHeight -
        mediaHeight
      );


    /*
      If the two columns are already close in height,
      sticky behaviour adds little value and can feel fussy.
    */

    if (difference < 120) {
      return;
    }


    const viewportHeight =
      getViewportHeight(root);


    if (
      centreHeight <
      mediaHeight
    ) {

      applyStickyState(
        centre,
        centreHeight,
        viewportHeight
      );

    } else {

      applyStickyState(
        media,
        mediaHeight,
        viewportHeight
      );

    }
  };


  const initialiseArticle = (root) => {
    buildToc(root);


    requestAnimationFrame(
      () => {
        updateBalancedSticky(root);
      }
    );


    if (
      root._kfResizeObserver
    ) {

      root._kfResizeObserver.disconnect();

    }


    if (
      'ResizeObserver' in window
    ) {

      const observer =
        new ResizeObserver(
          () => {

            window.clearTimeout(
              root._kfResizeTimer
            );


            root._kfResizeTimer =
              window.setTimeout(
                () => {
                  updateBalancedSticky(root);
                },
                80
              );

          }
        );


      const centre =
        root.querySelector(
          '[data-kf-article-centre]'
        );

      const media =
        root.querySelector(
          '[data-kf-media-rail]'
        );


      if (centre) {
        observer.observe(
          centre
        );
      }

      if (media) {
        observer.observe(
          media
        );
      }


      root._kfResizeObserver =
        observer;
    }
  };


  const initialiseAll = () => {

    document
      .querySelectorAll(
        '[data-kf-article-root]'
      )
      .forEach(
        initialiseArticle
      );

  };


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialiseAll,
      {
        once: true
      }
    );

  } else {

    initialiseAll();

  }


  let resizeTimer;


  window.addEventListener(
    'resize',
    () => {

      window.clearTimeout(
        resizeTimer
      );


      resizeTimer =
        window.setTimeout(
          initialiseAll,
          140
        );

    }
  );


  window.addEventListener(
    'load',
    initialiseAll
  );


  document.addEventListener(
    'shopify:section:load',
    (event) => {

      event.target
        .querySelectorAll?.(
          '[data-kf-article-root]'
        )
        .forEach(
          initialiseArticle
        );

    }
  );

})();
